<template>
  <nav class="max-w-5xl mx-auto flex flex-col items-center justify-center py-1 text-center">
    <router-link to="/" class="flex items-center">
      <img src="/logo.svg" alt="Melissa McCallum Logo" class="h-16  w-auto" />
    </router-link>

    <div class="flex flex-wrap justify-center gap-4 text-gray-600 text-sm font-medium w-full max-w-3xl">
      <router-link
          to="/"
          class="flex-1 text-center hover:text-blue-600 py-2"
          :class="{ 'text-blue-600 font-semibold': route.path === '/' }"
      >Home</router-link>

      <router-link
          to="/about"
          class="flex-1 text-center hover:text-blue-600 py-2"
          :class="{ 'text-blue-600 font-semibold': route.path === '/about' }"
      >About Me</router-link>

      <router-link
          to="/therapy"
          class="flex-1 text-center hover:text-blue-600 py-2"
          :class="{ 'text-blue-600 font-semibold': route.path === '/therapy' }"
      >Therapy</router-link>

      <router-link
          to="/SupervisionS"
          class="flex-1 text-center hover:text-blue-600 py-2"
          :class="{ 'text-blue-600 font-semibold': route.path === '/SupervisionS' }"
      >Supervision</router-link>

      <router-link
          to="/contact"
          class="flex-1 text-center hover:text-blue-600 py-2"
          :class="{ 'text-blue-600 font-semibold': route.path === '/contact' }"
      >Contact</router-link>
    </div>
  </nav>
</template>

<script setup>
import { useRoute } from 'vue-router'
const route = useRoute()
</script>
